import { MessageCircle, Phone } from 'lucide-react';
import { api } from '@/lib/api';
import { track } from '@/lib/analytics';

/**
 * Normalizza un numero di telefono in formato internazionale WhatsApp (senza +).
 * Se manca il prefisso, assume Italia (+39).
 */
function normalizePhone(raw) {
  if (!raw) return null;
  let n = String(raw).replace(/[^\d+]/g, '');
  if (n.startsWith('+')) n = n.slice(1);
  else if (n.startsWith('00')) n = n.slice(2);
  else if (n.startsWith('39')) { /* già IT */ }
  else n = '39' + n;
  return n.length >= 10 ? n : null;
}

/**
 * Bottone "Contatta su WhatsApp" con pre-compilato messaggio contestuale.
 * Traccia il click come contact_whatsapp su analytics + backend contact_events.
 */
export default function WhatsAppButton({ number, prefillMessage, listingId, batchId, className = '', variant = 'primary', label = 'Contatta su WhatsApp' }) {
  const normalized = normalizePhone(number);
  if (!normalized) return null;

  const openWhatsApp = async () => {
    const encoded = encodeURIComponent(prefillMessage || 'Salve, sono interessato al vostro annuncio su AgriNexus.');
    const url = `https://wa.me/${normalized}?text=${encoded}`;
    track('contact_whatsapp', { listing_id: listingId, batch_id: batchId });
    try {
      await api.post('/contact-events', { listing_id: listingId, batch_id: batchId, channel: 'whatsapp' });
    } catch (_) {/* silent */}
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const base = 'inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full text-sm font-medium transition-colors';
  const styles = variant === 'primary'
    ? 'bg-[#25D366] text-white hover:bg-[#20b856]'
    : 'border border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10';

  return (
    <button onClick={openWhatsApp} className={`${base} ${styles} ${className}`} data-testid="whatsapp-btn">
      <MessageCircle size={16}/> {label}
    </button>
  );
}

export function PhoneButton({ number, listingId, batchId, className = '' }) {
  const normalized = normalizePhone(number);
  if (!normalized) return null;

  const openPhone = async () => {
    track('contact_phone', { listing_id: listingId, batch_id: batchId });
    try {
      await api.post('/contact-events', { listing_id: listingId, batch_id: batchId, channel: 'phone' });
    } catch (_) {/* silent */}
    window.location.href = `tel:+${normalized}`;
  };

  return (
    <button onClick={openPhone} className={`inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full text-sm font-medium border border-border hover:bg-secondary transition ${className}`} data-testid="phone-btn">
      <Phone size={16}/> Chiama
    </button>
  );
}
